import React from 'react';
import {useHistory} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {SessionListingDatum} from '../PaperSubmissionSessionListing';

type ActionsCellProps = {
    session: SessionListingDatum,
    personId?: string,
    setCurrentSession: (session: SessionListingDatum) => void
};

/**
 * Modal zur Anzeige der Session-Details
 *
 * @constructor
 * @param session
 * @param personId
 * @param setCurrentSession
 */
const ActionsCell: React.FC<ActionsCellProps> = ({ session, personId, setCurrentSession}) => {
    const intl = useIntl();
    const history = useHistory();

    const navigateToEdit = (callForPapersSlug: string, submissionId: string) => {
        history.push(`/${callForPapersSlug}/edit/${submissionId}`);
    }

    return <>
        <span className='btn btn-link'
            onClick={() => setCurrentSession(session)}>
            <i className='fa fa-2x fa-calendar'
                data-toggle="tooltip"
                title={intl.formatMessage({ id: "myarea.listing.column.body.actions.view" })} />
        </span>
        {personId === session.paperSubmission.submittedBy.id &&
            <span className='btn btn-link'
                onClick={() => navigateToEdit(
                    session.paperSubmission.callForPapersUrlSlug,
                    session.paperSubmission.id
                )}>
                <i className='fa fa-2x fa-pencil'
                    data-toggle="tooltip"
                    title={intl.formatMessage({ id: "myarea.listing.column.body.actions.edit" })} />
            </span>
        }
    </>;
};

export default ActionsCell;
